/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Flexi = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8Z"
      />
      <path d="M8.25151 4.47776L8.90614 6.43571C8.94805 6.56174 9.06892 6.64701 9.20515 6.64701H11.323C11.6278 6.64701 11.7545 7.02597 11.508 7.20007L9.79446 8.41019C9.68435 8.48803 9.63822 8.62598 9.68019 8.752L10.3347 10.71C10.4289 10.9916 10.0972 11.2259 9.85079 11.0518L8.13724 9.84164C8.02702 9.7638 7.87776 9.7638 7.7677 9.84164L6.0542 11.0518C5.8077 11.2259 5.47609 10.9916 5.57018 10.71L6.22458 8.752C6.26672 8.62598 6.22059 8.48803 6.11031 8.41019L4.39698 7.20007C4.15048 7.02597 4.27717 6.64701 4.58189 6.64701H6.69963C6.83585 6.64701 6.95672 6.56174 6.99886 6.43571L7.65327 4.47776C7.74752 4.19622 8.15742 4.19622 8.25151 4.47776Z" />
    </BaseSvgIcon>
  )
}

export default Flexi
